<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-29 15:40:59
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchManage\PunchManage.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-21 13:59:12
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_punchManage_list_title')"
    pad="0"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    :exportBtn="hasBtn('export-' + Permission.permission)"
    :importBtn="hasBtn('import-' + Permission.permission)"
    :import-options="{
      api: Permission.api,
      templateUrl: Permission.templateUrl,
      success: (result) => {
        getType();
      },
    }"
    @export="onExport(Permission)"
  >
    <!-- content -->
    <template v-slot:page-main>
      <noContent v-if="!criteriaType.length" />
      <Taber
        contentBackground="transparent"
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        close-translate
      >
        <template
          v-for="(it, index) in criteriaType"
          :slot="`content-${index + 1}`"
        >
          <!-- 2021-04-06 去掉标题 brain -->
          <!-- <div class="title text--primary pa-3" :key="`title-${index}`">
            {{ $t("label_essweb_punchManage_list_criteriaTitle") }}
          </div> -->
          <Tabler
            v-if="it.punch_code.toLowerCase() == 'gps'"
            :headers="GPSHeader"
            :items="it.criteriaData"
            :totalCount="totalCount[index]"
            :height="
              iSEdited
                ? $vuetify.breakpoint.height - 335 - 48
                : $vuetify.breakpoint.height - 335 - 4
            "
            border
            :key="`table-${index}`"
            @change="
              (page, perpage, callback) => {
                getList(it.punch_code, index, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.gps_name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.criteria_gps_name) }}
              </div>
            </template>
            <template v-slot:item.gps_dis="{ item }">
              <div class="table-title text--primary">
                {{ item.within_distance_meter }}
              </div>
            </template>
            <template v-slot:item.gps_status="{ item }">
              <v-chip
                small
                :color="item.status ? 'green' : 'grey'"
                class="white--text"
                >{{
                  item.status
                    ? $t("label_essweb_system_status_onLabel")
                    : $t("label_essweb_system_status_offLabel")
                }}</v-chip
              >
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                v-if="
                  iSEdited && hasBtn('edit-admin-admin-clock-in-criteria-gps')
                "
                @click="toEdit(it.punch_code, item.uuid, index)"
              >
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn
                icon
                v-if="
                  iSEdited && hasBtn('delete-admin-admin-clock-in-criteria-gps')
                "
                @click="toDelete(it.punch_code, item.uuid, index)"
              >
                <span class="material-icons-round">delete</span>
              </v-btn>
              <v-btn
                icon
                v-if="
                  !iSEdited && hasBtn('view-admin-admin-clock-in-criteria-gps')
                "
                @click="toView(it.punch_code, item.uuid, index)"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
            <!-- <template v-slot:footer>
              <v-container fluid class="pa-0" v-if="it.punch_code.toLowerCase() == 'gps'">
                <v-btn
                  text
                  v-if="iSEdited"
                  class="mt-2 text-capitalize"
                  color="primary"
                  @click="toNew(it.punch_code, index)"
                >
                  {{ $t("label_essweb_punchManage_list_addCriteriaBtnLabel") }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template> -->
          </Tabler>

          <Tabler
            v-if="it.punch_code.toLowerCase() == 'wifi'"
            :headers="wifiHeader"
            :totalCount="totalCount[index]"
            :items="it.criteriaData"
            :height="
              iSEdited
                ? $vuetify.breakpoint.height - 335 - 48
                : $vuetify.breakpoint.height - 335 - 4
            "
            border
            :key="`table-${index}`"
            @change="
              (page, perpage, callback) => {
                getList(it.punch_code, index, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.wifi_name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.criteria_wifi_name) }}
              </div>
            </template>
            <template v-slot:item.wifi_ip="{ item }">
              <div class="table-title text--primary">{{ item.ssid }}</div>
            </template>
            <template v-slot:item.wifi_site="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.site_name) }}
              </div>
            </template>
            <template v-slot:item.wifi_status="{ item }">
              <v-chip
                small
                :color="item.status ? 'green' : 'grey'"
                class="white--text"
                >{{
                  item.status
                    ? $t("label_essweb_system_status_onLabel")
                    : $t("label_essweb_system_status_offLabel")
                }}</v-chip
              >
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                v-if="
                  iSEdited && hasBtn('edit-admin-admin-clock-in-criteria-wifi')
                "
                @click="toEdit(it.punch_code, item.uuid, index)"
              >
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn
                icon
                v-if="
                  iSEdited &&
                  hasBtn('delete-admin-admin-clock-in-criteria-wifi')
                "
                @click="toDelete(it.punch_code, item.uuid, index)"
              >
                <span class="material-icons-round">delete</span>
              </v-btn>
              <v-btn
                icon
                v-if="
                  !iSEdited && hasBtn('view-admin-admin-clock-in-criteria-wifi')
                "
                @click="toView(it.punch_code, item.uuid, index)"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
            <!-- <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider v-if="iSEdited"></v-divider>
                <v-btn
                  text
                  v-if="iSEdited"
                  class="mt-2 text-button"
                  color="primary"
                  @click="toNew(it.punch_code, index)"
                >
                  {{ $t("label_essweb_punchManage_list_addCriteriaBtnLabel") }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template> -->
          </Tabler>
          <Tabler
            v-if="it.punch_code.toLowerCase() == 'bluetooth'"
            :headers="blueToothHeader"
            :totalCount="totalCount[index]"
            :items="it.criteriaData"
            border
            :height="
              iSEdited
                ? $vuetify.breakpoint.height - 335 - 48
                : $vuetify.breakpoint.height - 335 - 4
            "
            :key="`table-${index}`"
            @change="
              (page, perpage, callback) => {
                getList(it.punch_code, index, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.bluetooth_name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.criteria_bluetooth_name) }}
              </div>
            </template>
            <template v-slot:item.bluetooth_site="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.site_name) }}
              </div>
            </template>
            <template v-slot:item.bluetooth_id="{ item }">
              <div class="table-title text--primary">
                {{ item.bluetooth_device_uuid }}
              </div>
            </template>
            <template v-slot:item.bluetooth_status="{ item }">
              <v-chip
                small
                :color="item.status ? 'green' : 'grey'"
                class="white--text"
                >{{
                  item.status
                    ? $t("label_essweb_system_status_onLabel")
                    : $t("label_essweb_system_status_offLabel")
                }}</v-chip
              >
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                v-if="
                  iSEdited &&
                  hasBtn('edit-admin-admin-clock-in-criteria-bluetooth')
                "
                @click="toEdit(it.punch_code, item.uuid, index)"
              >
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn
                icon
                v-if="
                  iSEdited &&
                  hasBtn('delete-admin-admin-clock-in-criteria-bluetooth')
                "
                @click="toDelete(it.punch_code, item.uuid, index)"
              >
                <span class="material-icons-round">delete</span>
              </v-btn>
              <v-btn
                icon
                v-if="
                  !iSEdited &&
                  hasBtn('view-admin-admin-clock-in-criteria-bluetooth')
                "
                @click="toView(it.punch_code, item.uuid, index)"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
            <!-- <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-btn
                  text
                  v-if="iSEdited"
                  color="primary"
                  class="mt-2 text-capitalize"
                  @click="toNew(it.punch_code, index)"
                >
                  {{ $t("label_essweb_punchManage_list_addCriteriaBtnLabel") }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template> -->
          </Tabler>

          <v-container
            fluid
            class="pa-0"
            v-if="it.punch_code.toLowerCase() == 'gps'"
            :key="`tabletools-${index}`"
          >
            <v-btn
              text
              v-if="iSEdited && hasBtn('add-admin-admin-clock-in-criteria-gps')"
              class="mt-2 text-capitalize"
              color="primary"
              @click="toNew(it.punch_code, index)"
            >
              {{ $t("label_essweb_punchManage_list_addCriteriaBtnLabel") }}
              <span class="material-icons-round">add</span>
            </v-btn>
          </v-container>
          <v-container
            fluid
            class="pa-0"
            v-if="it.punch_code.toLowerCase() == 'wifi'"
            :key="`tabletools-${index}`"
          >
            <v-divider v-if="iSEdited"></v-divider>
            <v-btn
              text
              v-if="
                iSEdited && hasBtn('add-admin-admin-clock-in-criteria-wifi')
              "
              class="mt-2 text-button"
              color="primary"
              @click="toNew(it.punch_code, index)"
            >
              {{ $t("label_essweb_punchManage_list_addCriteriaBtnLabel") }}
              <span class="material-icons-round">add</span>
            </v-btn>
          </v-container>
          <v-container
            fluid
            class="pa-0"
            v-if="it.punch_code.toLowerCase() == 'bluetooth'"
            :key="`tabletools-${index}`"
          >
            <v-btn
              text
              v-if="
                iSEdited &&
                hasBtn('add-admin-admin-clock-in-criteria-bluetooth')
              "
              color="primary"
              class="mt-2 text-capitalize"
              @click="toNew(it.punch_code, index)"
            >
              {{ $t("label_essweb_punchManage_list_addCriteriaBtnLabel") }}
              <span class="material-icons-round">add</span>
            </v-btn>
          </v-container>
        </template>
      </Taber>
    </template>
    <template v-slot:tools-main>
      <newGps :show="showNewGps" @close="showNewGps = false" @onNew="onNew" />
      <newWifi
        :show="showNewWifi"
        @close="showNewWifi = false"
        @onNew="onNew"
      />
      <newBluetooth
        :show="showNewBluetooth"
        @close="showNewBluetooth = false"
        @onNew="onNew"
      />
      <editBluetooth
        :show="showEditBluetooth"
        @close="
          showEditBluetooth = false;
          curBluetoothUuid = null;
        "
        :curUuid="curBluetoothUuid"
        @onEdit="onEdit"
      />
      <viewBluetooth
        :show="showViewBluetooth"
        @close="
          showViewBluetooth = false;
          curBluetoothUuid = null;
        "
        :curUuid="curBluetoothUuid"
        @onEdit="onEdit"
      />
      <editWifi
        :show="showEditWifi"
        @close="
          showEditWifi = false;
          curWifiUuid = null;
        "
        :curUuid="curWifiUuid"
        @onEdit="onEdit"
      />
      <viewWifi
        :show="showViewWifi"
        @close="
          showViewWifi = false;
          curWifiUuid = null;
        "
        :curUuid="curWifiUuid"
        @onEdit="onEdit"
      />
      <editGps
        :show="showEditGps"
        @close="
          showEditGps = false;
          curGpsUuid = null;
        "
        :curUuid="curGpsUuid"
        @onEdit="onEdit"
      />
      <viewGps
        :show="showViewGps"
        @close="
          showViewGps = false;
          curGpsUuid = null;
        "
        :curUuid="curGpsUuid"
        @onEdit="onEdit"
      />
    </template>
  </ContentLayout>
</template>
<script>
import newWifi from "@/Page/EssAdmin/Punch/PunchManage/components/Wifi/newWifi";
import editWifi from "@/Page/EssAdmin/Punch/PunchManage/components/Wifi/editWifi";
import viewWifi from "@/Page/EssAdmin/Punch/PunchManage/components/Wifi/viewWifi";
import newGps from "@/Page/EssAdmin/Punch/PunchManage/components/Gps/newGps";
import editGps from "@/Page/EssAdmin/Punch/PunchManage/components/Gps/editGps";
import viewGps from "@/Page/EssAdmin/Punch/PunchManage/components/Gps/viewGps";
import editBluetooth from "@/Page/EssAdmin/Punch/PunchManage/components/Bluetooth/editBluetooth";
import viewBluetooth from "@/Page/EssAdmin/Punch/PunchManage/components/Bluetooth/viewBluetooth";
import newBluetooth from "@/Page/EssAdmin/Punch/PunchManage/components/Bluetooth/newBluetooth";
import { mapGetters } from "vuex";
export default {
  name: "PunchManagement",
  components: {
    newWifi,
    editWifi,
    newGps,
    editGps,
    viewGps,
    viewWifi,
    editBluetooth,
    viewBluetooth,
    newBluetooth,
  },
  computed: {
    taber() {
      let arr = [];
      this.criteriaType.map((item) => {
        arr.push(item.criteria_type_abbr);
      });
      return arr;
    },
    Permission() {
      let tab = 1;
      switch (this.curTab) {
        case "tab-1":
          tab = 1;
          break;
        case "tab-2":
          tab = 2;
          break;
        case "tab-3":
          tab = 3;
          break;
        default:
          return { permission: "", api: "", templateUrl: "" };
          break;
      }
      if (!this.criteriaType || this.criteriaType.length <= 0) {
        return "";
      }
      switch (this.criteriaType[tab - 1]["punch_code"].toLowerCase()) {
        case "gps":
          return {
            permission: "admin-clock-in-criteria-gps",
            api: "/gps-criteria/import/",
            title: this.$getCommonLangValue(
              this.criteriaType[tab - 1]["criteria_type_name"]
            ),
            table: "ess_punch_criteria_gps",
            outurl: "/gps-criteria/export/",
            templateUrl:
              "https://assets.essencehr.io/web/ess-business/assets/punch-criteria-gps-import-template.xlsx",
          };
          break;
        case "wifi":
          return {
            permission: "admin-clock-in-criteria-wifi",
            api: "/wifi-criteria/import/",
            title: this.$getCommonLangValue(
              this.criteriaType[tab - 1]["criteria_type_name"]
            ),
            table: "ess_punch_criteria_wifi",
            outurl: "/wifi-criteria/export/",
            templateUrl:
              "https://assets.essencehr.io/web/ess-business/assets/punch-criteria-wifi-import-template.xlsx",
          };

          break;

        case "bluetooth":
          return {
            permission: "admin-clock-in-criteria-bluetooth",
            api: "/bluetooth-criteria/import/",
            title: this.$getCommonLangValue(
              this.criteriaType[tab - 1]["criteria_type_name"]
            ),
            table: "ess_punch_criteria_bluetooth",
            outurl: "/bluetooth-criteria/export/",
            templateUrl:
              "https://assets.essencehr.io/web/ess-business/assets/punch-criteria-bluetooth-import-template.xlsx",
          };

          break;

        default:
          return {
            permission: "",
            api: "",
            templateUrl: "",
            title: "",
            table: "",
            outurl: "",
          };
          break;
      }
    },
  },
  data() {
    return {
      totalCount: [0, 0, 0],
      showNewGps: false,
      showEditGps: false,
      showViewGps: false,
      iSEdited: false,
      showNewWifi: false,
      showEditWifi: false,
      showViewWifi: false,
      showNewBluetooth: false,
      showEditBluetooth: false,
      showViewBluetooth: false,
      curGpsUuid: null,
      curWifiUuid: null,
      curBluetoothUuid: null,
      curIndex: null,
      criteriaType: [],
      curTab: "tab-1",
      GPSHeader: [
        {
          text: "label_essweb_punchManage_list_gps_nameLabel",
          value: "gps_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_gps_distanceLabel",
          value: "gps_dis",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_gps_statusLabel",
          value: "gps_status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      wifiHeader: [
        {
          text: "label_essweb_punchManage_list_wifi_nameLabel",
          value: "wifi_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_wifi_siteNameLabel",
          value: "wifi_site",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_wifi_ipLabel",
          value: "wifi_ip",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_wifi_statusLabel",
          value: "wifi_status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      blueToothHeader: [
        {
          text: "label_essweb_punchManage_list_bluetooth_nameLabel",
          value: "bluetooth_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_bluetooth_siteNameLabel",
          value: "bluetooth_site",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_bluetooth_deviceIdLabel",
          value: "bluetooth_id",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchManage_list_bluetooth_statusLabel",
          value: "bluetooth_status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getType();
  },
  filters: {},
  methods: {
    onExport(p) {
      this.$Request({
        method: "POST",
        table: p.table,
        url: p.outurl,
        data: {},
        type: "export",
        export_title: p.title,
      });
    },
    getType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_criteria_type",
        url: "/criteria-type/get-criteria-type-list/",
        data: {},
      }).then((res) => {
        res.data.map((item, index) => {
          item.criteria_type_abbr = that.$getCommonLangValue(
            item.criteria_type_abbr
          );
          item["criteriaData"] = [];
          if (item.punch_code) {
            this.getList(
              item.punch_code,
              index,
              1,
              that.$tableSetting.perPageSize,
              () => {
                that.$store.dispatch("resetTable", new Date().getTime());
              }
            );
          }
        });
        that.criteriaType = res.data;
      });
    },
    getList: function (code, index, page, perpage, callback) {
      const that = this;
      let url = "";
      let table = "";
      switch (code.toLowerCase()) {
        case "gps":
          url = "/gps-criteria/get-gps-criteria-list/";
          table = "ess_punch_criteria_gps";
          break;
        case "bluetooth":
          url = "/bluetooth-criteria/get-bluetooth-criteria-list/";
          table = "ess_punch_criteria_bluetooth";
          break;
        case "wifi":
          url = "/wifi-criteria/get-wifi-criteria-list/";
          table = "ess_punch_criteria_wifi";
          break;
        default:
          break;
      }
      that
        .$Request({
          method: "POST",
          table: table,
          url: url,
          data: { cpage: page, pagesize: perpage },
        })
        .then((res) => {
          that.criteriaType[index]["criteriaData"] = res.data;
          that.totalCount[index] = res.totalcount;
          callback ? callback() : null;
        });
    },
    toNew: function (code, index) {
      const that = this;
      this.curIndex = index;
      switch (code.toLowerCase()) {
        case "gps":
          that.showNewGps = true;
          break;
        case "wifi":
          that.showNewWifi = true;
          break;
        case "bluetooth":
          that.showNewBluetooth = true;
          break;
        default:
          break;
      }
    },
    toEdit: function (code, uuid, index) {
      const that = this;

      this.curIndex = index;
      switch (code.toLowerCase()) {
        case "gps":
          that.curGpsUuid = uuid;
          that.showEditGps = true;
          break;
        case "wifi":
          that.curWifiUuid = uuid;
          that.showEditWifi = true;
          break;
        case "bluetooth":
          that.curBluetoothUuid = uuid;
          that.showEditBluetooth = true;
          break;
        default:
          break;
      }
    },
    toView: function (code, uuid, index) {
      const that = this;

      this.curIndex = index;
      switch (code.toLowerCase()) {
        case "gps":
          that.curGpsUuid = uuid;
          that.showViewGps = true;
          break;
        case "wifi":
          that.curWifiUuid = uuid;
          that.showViewWifi = true;
          break;
        case "bluetooth":
          that.curBluetoothUuid = uuid;
          that.showViewBluetooth = true;
          break;
        default:
          break;
      }
    },
    onNew: function (code, obj) {
      const that = this;
      let url = "";
      let table = "";
      let data = null;
      switch (code) {
        case "gps":
          // that.showNewGps = false;
          url = "/gps-criteria/add-gps-criteria-table/";
          table = "ess_punch_criteria_gps";
          data = {
            criteria_gps_name: that.$transCommonLangKey(obj.criteria_gps_name),
            criteria_gps_description: that.$transCommonLangKey(
              obj.criteria_gps_description
            ),
            within_distance_meter: obj.within_distance_meter,
            status: obj.status ? 1 : 0,
            effective_utc_datetime: that.$getTimeValue(
              obj.effective_utc_datetime
            ),
            // effective_time_zone: obj.effective_time_zone,//BJ
            expired_utc_datetime: that.$getTimeValue(obj.expired_utc_datetime),
            // expired_time_zone: obj.expired_time_zone,//BJ
            criteria_type_uuid: that.criteriaType[that.curIndex]["uuid"],
            remarks: obj.remarks,
          };
          break;
        case "bluetooth":
          // that.showNewBluetooth = false;

          url = "/bluetooth-criteria/add-bluetooth-criteria-table/";
          table = "ess_punch_criteria_bluetooth";
          data = {
            criteria_bluetooth_name: that.$transCommonLangKey(
              obj.criteria_bluetooth_name
            ),
            criteria_bluetooth_description: that.$transCommonLangKey(
              obj.criteria_bluetooth_description
            ),
            site_uuid: obj.site_uuid,
            bluetooth_major_code: obj.bluetooth_major_code,
            bluetooth_minor_code: obj.bluetooth_minor_code,
            bluetooth_device_uuid: obj.bluetooth_device_uuid,
            status: obj.status ? 1 : 0,
            effective_utc_datetime: that.$getTimeValue(
              obj.effective_utc_datetime
            ),
            // effective_time_zone: obj.effective_time_zone,//BJ
            expired_utc_datetime: that.$getTimeValue(obj.expired_utc_datetime),
            // expired_time_zone: obj.expired_time_zone,//BJ
            criteria_type_uuid: that.criteriaType[that.curIndex]["uuid"],
            remarks: obj.remarks,
          };
          break;
        case "wifi":
          // that.showNewWifi = false;
          url = "/wifi-criteria/add-wifi-criteria-table/";
          table = "ess_punch_criteria_wifi";
          data = {
            criteria_wifi_name: that.$transCommonLangKey(
              obj.criteria_wifi_name
            ),
            criteria_wifi_description: that.$transCommonLangKey(
              obj.criteria_wifi_description
            ),
            site_uuid: obj.site_uuid,
            ssid: obj.ssid,
            status: obj.status ? 1 : 0,
            ssid_encrypt: obj.ssid_encrypt,
            effective_utc_datetime: that.$getTimeValue(
              obj.effective_utc_datetime
            ),
            // effective_time_zone: obj.effective_time_zone,//BJ
            expired_utc_datetime: that.$getTimeValue(obj.expired_utc_datetime),
            // expired_time_zone: obj.expired_time_zone,//BJ
            criteria_type_uuid: that.criteriaType[that.curIndex]["uuid"],
            remarks: obj.remarks,
          };
          break;
        default:
          break;
      }
      that
        .$Request({
          method: "POST",
          table: table,
          url: url,
          data: data,
        })
        .then((res) => {
          that.showNewWifi = false;
          that.showNewGps = false;
          that.showNewBluetooth = false;
          that.getList(
            code,
            that.curIndex,
            1,
            that.$tableSetting.perPageSize,
            () => {
              that.$store.dispatch("resetTable", new Date().getTime());
            }
          );
        });
    },
    toDelete: function (code, uuid, index) {
      const that = this;
      this.curIndex = index;
      switch (code.toLowerCase()) {
        case "gps":
          that.curGpsUuid = uuid;
          that
            .$confirmDo(that.$t("label_essweb_punchManage_list_tab_gpsLabel"))
            .then((res) => {
              if (res) that.onDelete("gps", that.curIndex);
            });
          break;
        case "wifi":
          that.curWifiUuid = uuid;
          that
            .$confirmDo(that.$t("label_essweb_punchManage_list_tab_wifiLabel"))
            .then((res) => {
              if (res) that.onDelete("wifi", that.curIndex);
            });
          break;
        case "bluetooth":
          that.curBluetoothUuid = uuid;
          that
            .$confirmDo(
              that.$t("label_essweb_punchManage_list_tab_bluetoothLabel")
            )
            .then((res) => {
              if (res) that.onDelete("bluetooth", that.curIndex);
            });
          break;
        default:
          break;
      }
    },
    onDelete: function (code, index) {
      const that = this;
      let url = "";
      let table = "";
      let data = null;
      let curUuid = "";
      let text = "";
      switch (code) {
        case "gps":
          url = "/gps-criteria/delete-gps-criteria-table/";
          table = "ess_punch_criteria_gps";
          curUuid = that.curGpsUuid;
          text = that.$t(
            "message_essweb_punchManage_list_deleteGpsSuccessLabel"
          );
          break;
        case "wifi":
          url = "/wifi-criteria/delete-wifi-criteria-table/";
          table = "ess_punch_criteria_wifi";
          curUuid = that.curWifiUuid;
          text = that.$t(
            "message_essweb_punchManage_list_deleteWifiSuccessLabel"
          );
          break;
        case "bluetooth":
          url = "/bluetooth-criteria/delete-bluetooth-criteria-table/";
          table = "ess_punch_criteria_bluetooth";
          curUuid = that.curBluetoothUuid;
          text = that.$t(
            "message_essweb_punchManage_list_deleteBluetoothSuccessLabel"
          );
          break;
        default:
          break;
      }
      that
        .$Request({
          method: "POST",
          table: table,
          url: url,
          data: { uuids: curUuid },
        })
        .then((res) => {
          that.$showMessage({
            text: text,
            type: "success",
          });
          that.criteriaType[index].criteriaData = that.criteriaType[
            index
          ].criteriaData.filter((ele) => ele.uuid !== curUuid);
        });
    },
    onEdit: function (code, obj) {
      const that = this;
      let url = "";
      let table = "";
      let data = null;
      let text = "";
      switch (code) {
        case "gps":
          // that.showEditGps = false;
          url = "/gps-criteria/update-gps-criteria-table/";
          table = "ess_punch_criteria_gps";
          data = {
            uuid: obj.uuid,
            criteria_gps_name: this.$transCommonLangKey(
              obj.criteria_gps_name,
              obj.criteria_gps_name_save
            ),
            criteria_gps_description: this.$transCommonLangKey(
              obj.criteria_gps_description,
              obj.criteria_gps_description_save
            ),
            within_distance_meter: obj.within_distance_meter,
            status: obj.status ? 1 : 0,
            effective_utc_datetime: that.$getTimeValue(
              obj.effective_utc_datetime
            ),
            // effective_time_zone: obj.effective_time_zone,//BJ
            expired_utc_datetime: that.$getTimeValue(obj.expired_utc_datetime),
            // expired_time_zone: obj.expired_time_zone,//BJ
            criteria_type_uuid: that.criteriaType[that.curIndex]["uuid"],
            remarks: obj.remarks,
          };
          text = that.$t(
            "message_essweb_punchManage_list_updateGpsSuccessLabel"
          );
          break;
        case "bluetooth":
          // that.showEditBluetooth = false;
          url = "/bluetooth-criteria/update-bluetooth-criteria-table/";
          table = "ess_punch_criteria_bluetooth";
          data = {
            uuid: obj.uuid,
            criteria_bluetooth_name: this.$transCommonLangKey(
              obj.criteria_bluetooth_name,
              obj.criteria_bluetooth_name_save
            ),
            criteria_bluetooth_description: this.$transCommonLangKey(
              obj.criteria_bluetooth_description,
              obj.criteria_bluetooth_description_save
            ),
            bluetooth_major_code: obj.bluetooth_major_code,
            bluetooth_minor_code: obj.bluetooth_minor_code,
            site_uuid: obj.site_uuid,
            bluetooth_device_uuid: obj.bluetooth_device_uuid,
            status: obj.status ? 1 : 0,
            effective_utc_datetime: that.$getTimeValue(
              obj.effective_utc_datetime
            ),
            // effective_time_zone: obj.effective_time_zone,//BJ
            expired_utc_datetime: that.$getTimeValue(obj.expired_utc_datetime),
            // expired_time_zone: obj.expired_time_zone,//BJ
            criteria_type_uuid: that.criteriaType[that.curIndex]["uuid"],
            remarks: obj.remarks,
          };
          text = that.$t(
            "message_essweb_punchManage_list_updateBluetoothSuccessLabel"
          );
          break;
        case "wifi":
          // that.showEditWifi = false;
          url = "/wifi-criteria/update-wifi-criteria-table/";
          table = "ess_punch_criteria_wifi";
          data = {
            uuid: obj.uuid,

            criteria_wifi_name: this.$transCommonLangKey(
              obj.criteria_wifi_name,
              obj.criteria_wifi_name_save
            ),
            criteria_wifi_description: this.$transCommonLangKey(
              obj.criteria_wifi_description,
              obj.criteria_wifi_description_save
            ),
            site_uuid: obj.site_uuid,
            ssid: obj.ssid,
            status: obj.status ? 1 : 0,
            ssid_encrypt: obj.ssid_encrypt,
            effective_utc_datetime: that.$getTimeValue(
              obj.effective_utc_datetime
            ),
            // effective_time_zone: obj.effective_time_zone,//BJ
            expired_utc_datetime: that.$getTimeValue(obj.expired_utc_datetime),
            // expired_time_zone: obj.expired_time_zone,//BJ
            criteria_type_uuid: that.criteriaType[that.curIndex]["uuid"],
            remarks: obj.remarks,
          };
          text = that.$t(
            "message_essweb_punchManage_list_updateWifiSuccessLabel"
          );
          break;
        default:
          break;
      }
      this.curGpsUuid = null;
      this.curWifiUuid = null;
      this.curBluetoothUuid = null;
      that
        .$Request({
          method: "POST",
          table: table,
          url: url,
          data: data,
        })
        .then((res) => {
          that.showEditWifi = false;
          that.showEditGps = false;
          that.showEditBluetooth = false;
          that.$showMessage({
            text: text,
            type: "success",
          });
          that.getList(
            code,
            that.curIndex,
            1,
            that.$tableSetting.perPageSize,
            () => {
              that.$store.dispatch("resetTable", new Date().getTime());
            }
          );
        });
    },
  },
};
</script>
